import { AdminPanelComponent } from './admin-panel.component';
export { AdminPanelComponent }

export const ADMIN_COMPONENTS = [
  AdminPanelComponent
];
